import React, { useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const AUTO_LOGOUT_TIME = 10 * 60 * 1000; // 10 minutes

const AppRoute = (props) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const logout = () => {
    localStorage.removeItem("authUser");
    navigate("/login");
  };

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      logout();
    }, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    if (!localStorage.getItem("authUser")) {
      navigate("/login");
      return;
    }

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []);

  // 🔐 Route protection
  if (!localStorage.getItem("authUser")) {
    return <Navigate to="/login" replace />;
  }

  return <>{props.children}</>;
};

export default AppRoute;
